import { render, staticRenderFns } from "./popupCreateOrigen.vue?vue&type=template&id=0fe0a5f5&scoped=true"
import script from "./popupCreateOrigen.vue?vue&type=script&lang=js"
export * from "./popupCreateOrigen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0a5f5",
  null
  
)

export default component.exports